import installRegistry from './install_registry';
import publicPageComponents from './public_page_components';

installRegistry(publicPageComponents, 'public');
